import { useEffect, useMemo } from 'react';
import { resolveLogoSrc } from '../../../utils/imageUtils';
import { useTenantProfileQuery } from '../queries/useTenantProfileQuery';

/** Resolved display URL for the authenticated tenant's logo, or null when unset. */
export function useTenantLogoSrc(): string | null {
  const tenantQuery = useTenantProfileQuery();
  const { src, revokeUrl } = useMemo(
    () => resolveLogoSrc(tenantQuery.data?.logo),
    [tenantQuery.data?.logo],
  );

  useEffect(() => {
    if (revokeUrl == null) {
      return;
    }
    return () => {
      URL.revokeObjectURL(revokeUrl);
    };
  }, [revokeUrl]);

  return src;
}
